import { useMutation } from '@tanstack/react-query';

import type {
  CreateOnlineBookingEventRegistrationData,
  CreateOnlineBookingParticipantData,
  CreateOnlineBookingReservationData,
  OnlineBookingMutationResponse,
} from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useCreateOnlineBookingReservationMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      data: CreateOnlineBookingReservationData;
    }) =>
      HttpClient.request<OnlineBookingMutationResponse>({
        method: 'POST',
        url: params.url,
        data: { reservation: params.data },
      }),
  });

export const useCreateOnlineBookingParticipantMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      groupSessionId: number;
      data: CreateOnlineBookingParticipantData;
    }) =>
      HttpClient.request<OnlineBookingMutationResponse>({
        method: 'POST',
        url: params.url,
        data: {
          group_session_id: params.groupSessionId,
          participant: params.data,
        },
      }),
  });

// `event_id` sits beside the registration rather than in the path: the tree that lists events needs
// no login, so there is no parent resource here for a registration to hang off.
export const useCreateOnlineBookingEventRegistrationMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      eventId: number;
      data: CreateOnlineBookingEventRegistrationData;
    }) =>
      HttpClient.request<OnlineBookingMutationResponse>({
        method: 'POST',
        url: params.url,
        data: { event_id: params.eventId, registration: params.data },
      }),
  });
